var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:_vm.file.file_id,staticClass:"inspection-report__question-file",on:{"click":() => _vm.onSaveClick(_vm.file)}},[_c('Icon',{attrs:{"icon":"paperclip"}}),_c('a',{attrs:{"href":_vm.isPdf ? _vm.makeLink(_vm.file) : '#'}},[_vm._v(" "+_vm._s(_vm.file.file_name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }